import type { Thread } from "connected-components/ai-teammate/types/thread"

export interface PartitionedThreads {
  pinned: Thread[]
  recents: Thread[]
}

// Only a genuine boolean `true` pins a thread — a persisted "true" string (or any truthy non-boolean)
// stays in Recents, so a bad backend value can never silently promote a thread.
export function partitionThreads(threads: readonly Thread[]): PartitionedThreads {
  const pinned: Thread[] = []
  const recents: Thread[] = []
  for (const thread of threads) {
    if (thread.pinned === true) pinned.push(thread)
    else recents.push(thread)
  }
  return { pinned, recents }
}

// Pinning is offered only once the thread data carries a boolean `pinned` field (APP-3367 backend seam).
export function threadsSupportPinning(threads: readonly Thread[]): boolean {
  return threads.some((thread) => typeof thread.pinned === "boolean")
}
